import React, { useMemo } from "react"

import QuickView from "./quick-view"
import Item from "./item"
import InlineContentfulAd from "../ads/inline-contentful-ad"
import { Container, Heading } from "./styles"

const Review = ({ article, contentfulAdUnits, element, showAds, inlineAdIndex }) => {
  const { title, items, startIndex, quickView } = element
  if (quickView) {
    return <QuickView element={element} />
  }

  const MAX_AD_LIMIT = 5
  let adCount = 0

  const contentfulAd = useMemo(
    () => ({
      mobile: contentfulAdUnits?.find(
        (unit) => unit.device === "Mobile" && unit.layout === "Horizontal Rectangle",
      ),
      desktop: contentfulAdUnits?.find(
        (unit) => unit.device === "Desktop / Tablet" && unit.layout === "Horizontal Rectangle",
      ),
    }),
    [contentfulAdUnits],
  )

  const renderAd = (item) => {
    const ad =
      contentfulAd.mobile || contentfulAd.desktop ? (
        <InlineContentfulAd key={`review-inline-contentful-ad-${item.id}`} element={contentfulAd} />
      ) : null

    if (!(contentfulAd.mobile || contentfulAd.desktop)) {
      inlineAdIndex.current += 1
    }
    adCount += 1

    return ad
  }

  return (
    <Container>
      <Heading id={`mbg-${element.anchor}`} role="heading">
        {title}
      </Heading>
      {items.map((item, idx) => (
        <React.Fragment key={`review-item-${item.id}`}>
          <Item idx={startIndex + idx} {...item} articleId={article.id} />
          {showAds && idx % 2 === 1 && adCount < MAX_AD_LIMIT && renderAd(item)}
        </React.Fragment>
      ))}
    </Container>
  )
}

export default Review
